<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item "><router-link :to="getHomePath()">Home</router-link></li>
        <li class="breadcrumb-item active" aria-current="page">
          <span v-if="menu.id">Edici&oacute;n de menú web</span>
          <span v-else>Creación de menú web</span>
        </li>
      </ol>
    </nav>
    <draf-message @draft_resolved="initMenu()" :menu="menu" />
    <form>
      <div class="container-fluid">
        <div v-if="successMessage" class="alert alert-success" role="alert">
          {{ successMessage }}
        </div>
        <div v-if="errorMessages.length" class="alert alert-danger" role="alert">
          <p v-for="message in errorMessages">{{ message }}</p>
        </div>
        <div class="contact-form">
          <h2 v-if="menu.id" class="text-center">Edici&oacute;n de menú web</h2>
          <h2 v-else class="text-center">Creación de menú web</h2>
          <form class="form-horizontal">
            <div class="form-group">
              <!-- Nombre -->
              <label for="name" class="font-weight-bold">Nombre</label>
              <input
                  class="form-control"
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Nombre"
                  :value="menu.name"
                  @change="onNameUpdate($event)"
              >
              <div id="nameHelp" class="form-text">{{ nameText }}</div>
            </div>
            <div class="form-group">
              <!-- Clase CSS -->
              <label for="description" class="font-weight-bold">Clase CSS</label>
              <input
                  class="form-control"
                  type="text"
                  id="css_class"
                  name="css_class"
                  placeholder="Clase CSS"
                  :value="menu.css_class"
                  @change="onCssClassUpdate($event)"
              >
              <div id="cssClassHelp" class="form-text">{{ cssClassText }}</div>
            </div>
            <div class="form-group">
              <!-- Descripcion -->
              <label for="description" class="font-weight-bold">Descripción</label>
              <input
                  class="form-control"
                  type="text"
                  id="description"
                  name="description"
                  placeholder="Descripción"
                  :value="menu.description"
                  @change="onDescriptionUpdate($event)"
              >
              <div id="descriptionHelp" class="form-text">{{ descriptionText }}</div>
            </div>
            <div class="form-group">
              <!-- Tipo -->
              <label for="type" class="font-weight-bold">Tipo</label>
              <type-selector
                  @update="onTypeUpdate"
                  :selectedValue="menu.type"
              />
              <div id="typeHelp" class="form-text">{{ typeText }}</div>
            </div>
            <div class="col">
              <!-- Elemento padre del submenú -->
              <label for="parent_web_menu_item" class="font-weight-bold">Elemento padre del submenú</label>
              <menu-item-selector
                  @update="onParentWebMenuItemUpdate"
                  @error="onComponentError"
                  name="parent_web_menu_item_id"
                  id="parent_web_menu_item_id"
                  :selectedValue="menu.parent_web_menu_item_id"
              />
              <div id="parentWebMenuItemHelp" class="form-text">{{ parentWebMenuItemText }}</div>
            </div>
            <div class="form-group">
              <!-- Posición del submenu -->
              <label for="type" class="font-weight-bold">Posición</label>
              <position-selector
                  @update="onPositionUpdate"
                  :selectedValue="menu.position"
              />
              <div id="typeHelp" class="form-text">{{ positionText }}</div>
            </div>
            <div class="col">
              <!-- Id de etiqueta del título del menú -->
              <label for="title_label_id" class="font-weight-bold">Id de etiqueta del título del menú</label>
              <input
                  class="form-control"
                  type="text"
                  id="title_label_id"
                  name="title_label_id"
                  placeholder="Id de etiqueta"
                  :value="menu.title_label_id"
                  @change="onTitleLabelIdUpdate($event)"
              >
              <div id="titleLabelIdHelp" class="form-text">{{ titleLabelIdText }}</div>
              <div v-if="labelText" class="form-text">Texto de la etiqueta {{ menu.title_label_id }}: <b>"{{ labelText }}"</b></div>
            </div>
            <div class="form-group">
              <!-- status del menu -->
              <label for="is_disabled" class="font-weight-bold">¿Está Desactivado?</label>
              <div>
                <toggle-switch
                    @update="onIsDisabledUpdate"
                    name="is_disabled"
                    id="is_disabled"
                    :checked="onIsDisabledUpdateIsChecked"
                />
              </div>
              <div id="isDisabledHelp" class="form-text">{{ isDisabledText }}</div>
            </div>
            <div class="text-center text-center layer-button">
              <button type="button" @click="sendData" class="btn btn-primary" :disabled='waiting'>
                <span v-if="waiting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Enviar
              </button>
            </div>
          </form>
          <div v-if="menu.id" class="text-center text-center layer-button">
            <router-link :to="getListMenuItemsPath(menu.id)">
              <button type="button" class="btn btn-primary">
                Listar elementos del menú
              </button>
            </router-link>
          </div>
        </div>
        <div v-if="isDevServer"><pre>{{ menu }}</pre></div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios';
import HelpTexts from '@/utils/HelpTexts.js'
import BaseMenuView from '@/views/BaseMenuView.vue'
import MenuValidator from '@/validators/MenuValidator.js'
import TypeSelector from '@/components/Form/MenuTypeSelector.vue'
import MenuItemSelector from '@/components/Form/MenuItemSelector.vue'
import ToggleSwitch from '@/components/Form/ToggleSwitch.vue'
import DrafMessage from '@/components/DrafMessage.vue'
import VueScrollTo from "vue-scrollto";
import PositionSelector from '@/components/Form/PositionSelector.vue'
import Url from '@/core/Url.js'

export default {
  name: 'edit-menu',
  extends: BaseMenuView,
  data () {
    return {
      labelText : '',
    };
  },
  components: {
    'type-selector' : TypeSelector,
    'toggle-switch' : ToggleSwitch,
    'draf-message' : DrafMessage,
    'menu-item-selector' : MenuItemSelector,
    'position-selector' : PositionSelector,
  },
  computed: {
    nameText: function () {
      return HelpTexts.getMenuNameText();
    },
    descriptionText: function () {
      return HelpTexts.getMenuDescriptionText();
    },
    cssClassText: function () {
      return HelpTexts.getMenuCssClassText();
    },
    typeText: function () {
      return HelpTexts.getMenuTypeText();
    },
    positionText: function () {
      return HelpTexts.getMenuPositionText();
    },
    parentWebMenuItemText: function () {
      return HelpTexts.getParentWebMenuItemText();
    },
    titleLabelIdText: function () {
      return HelpTexts.getTitleLabelIdText();
    },
    onIsDisabledUpdateIsChecked: function () {
      return this.menu.is_disabled === '1';
    },
    isDisabledText: function () {
      return HelpTexts.getMenuIsDisabledText();
    },
  },
  methods: {
    sendData () {
      if (this.validateMenu()) {
        if (this.menu.id) {
          this.updateMenu();
        } else {
          this.createMenu();
        }
      }
      this.scrollToTop();
    },
    validateMenu () {
      this.successMessage = '';
      this.errorMessages = MenuValidator.validate(this.menu);
      return this.errorMessages.length == 0;
    },
    createMenu() {
      this.waiting = true;
      axios
          .post(this.getMenuUrl(), this.menu)
          .then(response => {
            if (response.data.result) {
              this.menu = response.data.data;
              this.successMessage = "Menú creado correctamente";
            } else {
              this.errorMessages.push("Se ha producido un error al crear el menú.");
            }
          }).catch(() => {
        this.errorMessages.push("Se ha producido un error al crear el menú.");

      }).finally(() => {
        this.waiting = false;
      });
    },
    updateMenu() {
      this.waiting = true;
      axios
          .put(this.getMenuUrl(), this.menu)
          .then(response => {
            if (response.data.result) {
              this.initMenu();
              this.successMessage = "Menú actualizado correctamente";
            } else {
              this.errorMessages.push("Se ha producido un error al actualizar el menú.");
            }
          }).catch(() => {
        this.errorMessages.push("Se ha producido un error al actualizar el menú.");

      }).finally(() => {
        this.waiting = false;
      });
    },
    updateLabelText(label_id) {
      this.waiting = true;
      axios
          .get(Url.getLabelUrl(label_id, 'es'))
          .then(response => {
            if (response.data.result) {
              this.labelText = response.data.data.label;
            } else {
              this.errorMessages.push("Se ha producido un error al actualizar el menú.");
            }
          }).catch(() => {
        this.errorMessages.push("Se ha producido un error al consultar la etiqueta.");
      }).finally(() => {
        this.waiting = false;
      });
    },
    scrollToTop() {
      VueScrollTo.scrollTo('nav');
    },
    onNameUpdate (event) {
      this.menu.name = event.target.value;
    },
    onCssClassUpdate (event) {
      this.menu.css_class = event.target.value;
    },
    onDescriptionUpdate (event) {
      this.menu.description = event.target.value;
    },
    onTitleLabelIdUpdate (event) {
      this.menu.title_label_id = event.target.value;
      if (this.menu.title_label_id) {
        this.updateLabelText(this.menu.title_label_id);
      }
    },
    onTypeUpdate (value) {
      this.menu.type = value;
    },
    onPositionUpdate (value) {
      this.menu.position = value;
    },
    onIsDisabledUpdate(value) {
      this.menu.is_disabled = value ? '1' : '0';
    },
    onParentWebMenuItemUpdate (value) {
      this.menu.parent_web_menu_item_id = value;
    },
    onComponentError (message) {
      this.errorMessages.push(message);
    },
  },
  created () {
    this.initMenu();
    setTimeout(()=>{
      if (this.menu.title_label_id) {
        this.updateLabelText(this.menu.title_label_id);
      }
    }, 1500)
  }
}
</script>

<style>
.form-horizontal{
  display:block;
  width:50%;
  margin:0 auto;
}
</style>
